import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import deleteItem from './deleteItem';

export default (item, filterData) => (dispatch) => {
    const dataAlert = {
        confirmText: i18next.t('Accept'),
        onSuccess: () => dispatch(deleteItem(item.id, filterData)),
        title: i18next.t('Delete item'),
        type: alerts.ALERT_TYPE_CONFIRM,
        haveTextCaptcha: true,
        textToValidate: i18next.t('Delete').toUpperCase(),
    };

    dispatch(alerts.actions.show(dataAlert));
};
